// Generated by ReScript, PLEASE EDIT WITH CARE


var isd_code = "+91";

var phablet_size = 559.0;

var getPartnerAppTitle = "GET PARTNER APP";

var name_error_msg = "Enter the name";

var mobile_error_msg = "Enter mobile number";

var city_error_msg = "Please select a city";

var vehicle_error_msg = "Please select a vehicle";

var source_error_msg = "This field is required";

var ack_msg = "THANK YOU FOR REGISTRATION";

var ack_desc = "We will get back to you shortly";

var req_msg = "Register More";

var app_download_link = "https://app.adjust.com/1l1fw2j2?engagement_type=fallback_click";

var ga_download_porter_click = " App Download/<Click>";

var loading_vehicles = "Laoding Vehicles...";

var try_again = "Something went wrong. Try Again...";

export {
  isd_code ,
  phablet_size ,
  getPartnerAppTitle ,
  name_error_msg ,
  mobile_error_msg ,
  city_error_msg ,
  vehicle_error_msg ,
  source_error_msg ,
  ack_msg ,
  ack_desc ,
  req_msg ,
  app_download_link ,
  ga_download_porter_click ,
  loading_vehicles ,
  try_again ,
}
/* No side effect */
